export const fr = { 1: 'Magistrat', 2: 'Conjoint', 3: 'Père', 4: 'Mère', 5: 'Enfant' }

export const ar = { 1: 'القاضي', 2: 'القرين', 3: 'الأب', 4: 'الأم', 5: 'الابن' }

export const en = { 1: 'Magistrate', 2: 'Spouse', 3: 'Father', 4: 'Mother', 5: 'Child' }
